export const WS_MESSAGE_TYPE = {
    CHAT_MESSAGE: 'CHAT_MESSAGE',
    USER_STATUS_UPDATE: 'USER_STATUS_UPDATE',
    NOTIFICATION_STATUS_UPDATED: 'NOTIFICATION_STATUS_UPDATED'
};